import { z } from "zod";

import { useGetQuery, type UseGetQueryOptions } from "../../api";
import { environmentConfig } from "../../environment";
import { APP_V2_APP_EVENTS } from "../../lib";

const agentProfilePictureResponseSchema = z.object({
  distribution_url: z.string(),
});

interface GetAgentProfilePictureParams {
  agentId: string;
}
export type AgentProfilePictureResponse = z.infer<typeof agentProfilePictureResponseSchema>;

export function useAgentProfilePicture(
  params: GetAgentProfilePictureParams,
  options: UseGetQueryOptions<AgentProfilePictureResponse> = {}
) {
  const { agentId } = params;

  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/agentProfile/${agentId}/profile-image-distribution-url`,
    responseSchema: agentProfilePictureResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_AGENT_PROFILE_PICTURE_FAILURE,
    },
    // It's ok to have a 404 here, however, if we don't set this to false,
    // this hook will throw and cause a global 404 error
    useErrorBoundary: false,
    retry: (failureCount, error) => failureCount < 3 && error.response?.status !== 404,
    ...options,
  });
}
